import { Typography } from "antd"

const { Text } = Typography

interface IAsinsKeywordsCount {
  asinsCount: number
  keywordsCount: number
}

const AsinsKeywordsCount: React.FC<IAsinsKeywordsCount> = ({ asinsCount, keywordsCount }) => {
  return (
    <Text>
      {asinsCount} ASINS | {keywordsCount} Keywords
    </Text>
  )
}

export default AsinsKeywordsCount
